import { Module } from 'wrapper6'
import Swiper from 'swiper/bundle'
import ObjectFitClass from '../utils/_object-fit'

const $ = jQuery

export default class PostsSlider extends Module {
  ready (app) {
    const sliderWrappers = document.querySelectorAll('.mtt-posts-slider')

    if (sliderWrappers.length) {
      for (let i = 0; i < sliderWrappers.length; i++) {
        const wrapper = sliderWrappers[i]

        const slider = new Slider(wrapper)
      }
    }
  }
}

class Slider {
  constructor (wrapper) {
    this.wrapper = wrapper
    this.loader = document.querySelector('#loader')

    this.slider = this.Slider()
    this.addFilters()
  }

  Slider () {
    const postType = this.wrapper.getAttribute('data-post')

    const options = {
      slidesPerView: 1.2,
      watchOverflow: true,
      spaceBetween: 24,
      navigation: {
        nextEl: this.wrapper.querySelector('.arrow--next'),
        prevEl: this.wrapper.querySelector('.arrow--prev')
      },
      lazy: {
        loadPrevNext: true,
        checkInView: true
      },
      observer: true,
      observeParents: true
    }

    switch (postType) {
      case 'events':
      case 'post':
      case 'applications':
        options.breakpoints = {
          580: {
            slidesPerView: 2
          },
          900: {
            slidesPerView: 3
          }
        }
        break
      case 'products':
        options.breakpoints = {
          580: {
            slidesPerView: 2
          },
          900: {
            slidesPerView: 3
          },
          1100: {
            slidesPerView: 4
          }
        }
        break
      default:
        break
    }

    const slider = new Swiper(this.wrapper.querySelector('.swiper-container'), options)

    return slider
  }

  addFilters () {
    if (this.wrapper) {
      const terms = this.wrapper.querySelectorAll('[data-id]')

      for (let i = 0; i < terms.length; i++) {
        const term = terms[i]

        term.addEventListener('click', () => {
          if (this.wrapper.querySelector('.mtt-posts-slider__term--active')) {
            this.wrapper.querySelector('.mtt-posts-slider__term--active').classList.remove('mtt-posts-slider__term--active')
          }

          term.classList.add('mtt-posts-slider__term--active')
          this.filterPosts()
        })
      }
    }
  }

  filterPosts () {
    this.loader.classList.add('show')

    const data = {
      action: 'filter_posts_slider',
      postType: this.wrapper.getAttribute('data-post'),
      term: this.wrapper.querySelector('.mtt-posts-slider__term--active').getAttribute('data-id')
    }

    $.post(main_theme_objects.ajax_url, data, (response) => {
      if (response.markup) {
        this.wrapper.querySelector('.swiper-wrapper').innerHTML = response.markup
        this.slider.update()
        this.slider.lazy.load()
      }

      this.loader.classList.remove('show')

      new ObjectFitClass()
    })
  }
}
